// Import the localization package.
import { default as config } from '../config'

// Import the language files.
import { default as english } from './en'
import { default as french } from './fr'
import { default as chinese_simplified } from './zh-cn'

var locales = {
  'en': english,
  'fr': french,
  'zh-cn': chinese_simplified
};

/**
 * 从指定obj数据中找到path的值
 * @param {*} obj 
 * @returns 
 */
function translateFunction(obj) {
  function getValue(path) {
    if (obj === null || obj == undefined || path == null || path == undefined) {
      return undefined
    }
    if (!path) {
      return obj;
    }
    const keys = Array.isArray(path) ? path : path.split('::');
    const key = keys.shift();
    return keys.length ? translateFunction(obj[key])(keys.join('.')) : obj[key]
  }
  return getValue
}

export default translateFunction(locales[config.locale])
